const TedFarayandIcon = () => (
  <div>
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.74658 5.92188H12.2466"
        stroke="#4583EC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75342 5.92188L5.25342 6.42188L6.75342 4.92188"
        stroke="#4583EC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74658 10.5859H12.2466"
        stroke="#4583EC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75342 10.5859L5.25342 11.0859L6.75342 9.58594"
        stroke="#4583EC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49992 14.6693H10.4999C13.8333 14.6693 15.1666 13.3359 15.1666 10.0026V6.0026C15.1666 2.66927 13.8333 1.33594 10.4999 1.33594H6.49992C3.16659 1.33594 1.83325 2.66927 1.83325 6.0026V10.0026C1.83325 13.3359 3.16659 14.6693 6.49992 14.6693Z"
        stroke="#4583EC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default TedFarayandIcon;
